.outer {
  position: relative;
  width: 55%;
  padding: 0.5rem;
  border-radius: 0.9rem;
  /* border: 1px solid ; */
  background-color: var(--main-bg-color);
  margin: -1.5rem 0 0 2rem;
}

.button {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  border-radius: 0.4rem;
  width: 100%;
}

.button:hover {
  border-radius: 0.4rem;
  width: 100%;
}

.debt {
  border: 1px solid var(--green-secondary-color) !important;
  background-color: var(--green-secondary-bg-color) !important;
}

.debt:hover {
  background-color: var(--green-secondary-hvr-color) !important;
}

.std {
  border: 1px solid var(--green-primary-color) !important;
  background-color: var(--green-primary-bg-color) !important;
}

.std:hover {
  background-color: var(--green-primary-hvr-color) !important;
}
